import axios from 'axios';

function getToken() {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
        return undefined;
    }
    const state = JSON.parse(serializedState);
    if (state && state.auth && state.auth.user && state.auth.user.AccessToken) {
        return state.auth.user.AccessToken
    } else {
        return undefined;
    }
}

async function httpGet(url, params, customUrl = false) {
    var data;
    var token = getToken();
    // var URI = "http://localhost:4009/";
    // var URI = "https://englishforward.site:4009/";
    // var URI = "https://api-uat.englishforward.com/";
    var URI = "https://api.englishforward.com/";
    var headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'access-token': token
        }
    if(customUrl){
        URI = customUrl;
        headers = {}
    }
    await axios.get(URI + url, {
        params: params,
        headers: headers
    })
        .then(res => {
            if (res.statusCode === 400) {
                data = { status: 0, message: 'fail in server validation' };
            }
            else {
                data = res.data;
            }
        }).catch((err) => {
            console.log('err service', err.message);
            data = { status: 0, message: err.message };
        })
    return data;
}

async function httpPost(url, dataArr, params, format = "application/json") {
    var data;
    var token = getToken();
    // var URI = "http://localhost:4009/";
    // var URI = "http://api.dev.cluster.englishforward.com/";
    // var URI = "https://englishforward.site:4009/";
    // var URI = "https://api-uat.englishforward.com/";
    var URI = "https://api.englishforward.com/";
    await axios.post(URI + url, dataArr, {
        params: params, 
        headers: {
            'Content-Type': format,
            'Access-Control-Allow-Origin': '*',
            'access-token': token
        }
    })
        .then(res => {
            if (res.statusCode === 400) {
                data = { status: 0, message: 'fail in server validation' };
            }
            else {
                data = res.data;
            }
        }).catch((err) => {
            console.log('err service', err.message);
            data = { status: 0, message: err.message };
        })
    return data;
}

export { httpGet, httpPost };